enum PerspectiveCategory {
  WANT = 'WANT',
  NEED = 'NEED',
  UNCLEAR = 'UNCLEAR',
  DONT_WANT = 'DONT_WANT',
}

export default PerspectiveCategory;
